import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks";
import { Skeleton } from "antd";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";


export const ExportInformation: FC = () => {
  const { data, isLoading } = useGetDetailRequests();
  if (isLoading) return <Skeleton />;

  return (
    <Box title="Thông tin phiếu thay đổi/bổ sung nhân sự khóa học">
      <div className="list">
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Họ và tên người yêu cầu</p>
            <strong>{data.createdBy.user.displayName}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Cơ quan/Đơn vị</p>
            <strong>{data.fields.eDepartment}</strong>
          </div>
        </div>

        
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Nghiệp vụ</p>
            <strong>{data.fields.eMajor}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Môn học</p>
            <strong>{data.fields.eCourse}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Ngày</p>
            <strong>{getDDMMYYYFormat(data.fields.eCourseDate)} - {getDDMMYYYFormat(data.fields.eCourseDateEnd)}</strong>
          </div>
        </div>
      </div>
    </Box>
  );
};
